import { render, staticRenderFns } from "./packageSeriesList.vue?vue&type=template&id=6164074e&"
import script from "./packageSeriesList.vue?vue&type=script&lang=js&"
export * from "./packageSeriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports